module.exports = __webpack_public_path__ + "img/noinfo.f0020400.png";